import NewSlideshow from '../../classes/NewSlideshow';
import {setStyles} from '../../../utils/iterators/setStyles';

const CATEGORY_ID_ATTRIBUTE = 'data-group-id';

const ACTIVE_CLASS = 'active';

const initProjectInfo = () => {
	document.querySelectorAll( 'section.project-info' ).forEach( ( component ) => {
		const sliderWrapper = component.querySelector( 'div.slider-wrapper' );
		const categoriesWrapper = component.querySelector( 'ul.categories' );

		const switchCategory = ( ...args ) => {
			/* eslint-disable-next-line */
			let activeSlide = sliderInstance._slides[sliderInstance._currentIndex];
			
			// Извините, временени не было сделать нормально
			if ( sliderInstance._currentIndex === -1 )
			{
				activeSlide = sliderInstance._slides[sliderInstance._slides.length - 1];
			}
			else if ( sliderInstance._currentIndex === sliderInstance._slides.length )
			{
				activeSlide = sliderInstance._slides[0];
			}

			const newActiveCategoryId = activeSlide.getAttribute( CATEGORY_ID_ATTRIBUTE );

			categoriesWrapper.querySelectorAll( ( `button.${ACTIVE_CLASS}` ) ).forEach( ( activeButton ) => activeButton.classList.remove( ACTIVE_CLASS ) );

			const newButton = categoriesWrapper.querySelector( `button[${CATEGORY_ID_ATTRIBUTE}="${newActiveCategoryId}"]` );

			newButton.classList.add( ACTIVE_CLASS );
		};
		
		const sliderInstance = new NewSlideshow( {
			element: sliderWrapper,
			loop: true,
			beforeSwitchCallback: switchCategory,
		} );

		sliderInstance.init();

		categoriesWrapper.addEventListener( 'click', ( evt ) => {
			const button = evt.target.closest( `button[${CATEGORY_ID_ATTRIBUTE}]` );

			if ( !button )
			{
				return;
			}

			const newActiveCategoryId = button.getAttribute( CATEGORY_ID_ATTRIBUTE );

			/* eslint-disable-next-line */
			const newActiveSlideIndex = sliderInstance._slides.findIndex( ( slide ) => slide.getAttribute( CATEGORY_ID_ATTRIBUTE ) === newActiveCategoryId );

			if ( newActiveSlideIndex === -1 )
			{
				return;
			}

			// Извините, временени не было сделать нормально
			sliderInstance._calculateAutoWidthStep();

			sliderInstance._currentIndex = newActiveSlideIndex;
			sliderInstance._calculateAutoWidthPosition();
			sliderInstance._adjustSlides();

			setStyles( sliderInstance._slidesContainer, {
				transform: `matrix( 1, 0, 0, 1, ${sliderInstance._currentPosition}, 0 )`,
				transition: `transform 0.4s ease-in-out`,
			} );
	

			sliderInstance._handleTransition();
		} );
	} );
};

export {
	initProjectInfo,
};
